import { render, staticRenderFns } from "./jobPost.vue?vue&type=template&id=94c67f6a"
import script from "./jobPost.vue?vue&type=script&lang=js"
export * from "./jobPost.vue?vue&type=script&lang=js"
import style0 from "./jobPost.vue?vue&type=style&index=0&id=94c67f6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports